import {
  CateringEventTier,
  MANPOWER_CATEGORIES,
} from "types/CateringEvent";

/**
 * Compute manpower estimates from branch config based on PAX and tier.
 * - Rounds PAX up to nearest 100, clamped to [100, 1000]
 * - Returns all categories with 0 if tier is NOT_APPLICABLE or no matching config found
 */
export function computeManpowerEstimate(
  config: Record<string, Record<string, Record<string, number>>> | undefined,
  pax: number,
  tier: CateringEventTier
): Record<string, number> {
  const empty: Record<string, number> = {};
  for (const cat of MANPOWER_CATEGORIES) {
    empty[cat] = 0;
  }

  if (tier === CateringEventTier.NOT_APPLICABLE || !pax || pax < 1 || !config) {
    return empty;
  }

  const paxBucket = Math.min(Math.max(Math.ceil(pax / 100) * 100, 100), 1000);
  const estimates = config[String(paxBucket)]?.[tier];

  if (!estimates) {
    return empty;
  }

  const result: Record<string, number> = { ...empty };
  for (const [key, value] of Object.entries(estimates)) {
    result[key] = value;
  }
  return result;
}
